/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const Banner = {
 collectibles:   {
        image: "https://i.ibb.co/fkdWqJJ/collectibles-1.jpg",
        title: "Collectibles",
        body: `Unlock $1 Billion market of Traditional “Physical” rare collectibles including coins and whiskey as NFTs. Address Human Desire and Natural Tendency to collect things that are eye-catching and rare.`,
        footer: `Enable leading brands to expand reach to Gen-Z by issuing collectibles.`,
        blurBox: true,
        align: 'left'
    },
sports:{
    image: "https://i.ibb.co/449SBLy/sports.jpg",
    title: "Sports",
    body: `Curate and Monetize Journey of Achievements as Digital Collectibles including Individual World Records, Team/Franchise Wins. Create continued anticipation and build sustainable revenue stream.`,
    footer: `Engage and Incentivize fans using Digital Collectibles as Tokens and engage by Gamification.`,
    blurBox: true,
    align: 'left'
},
entertainment:{
    image: "https://i.ibb.co/cXmjtCd/entertainment.jpg",
    title: "Entertainment",
    body: `Curate and Monetize Achievements, Unique Moments, Creations and Back Stage Moments as Digital Collectibles and NFTs.`,
    footer: `Enable Production houses and Brands to cross sell services to NFT owners.`,
    blurBox: true,
    align: 'left'
},

"gba-2022-collection-curated-by-magi":{
    image: "https://i.ibb.co/JHJFSLc/gba.jpg",
    title: "The New Renaissance",
    body: `A Carbon-Neutral Social NFT Metaverse for Transformational Healing Art.`,
    footer: `Decentralizing Transformational Healing Art Social Metaverse.`,
    blurBox: true,
    align: 'left'
},

"gba-2022-art-meets-blockchain":{
    image: "https://i.ibb.co/gVK6MJ7/art-img.png",
    title: "GBA 2022 - Art meets Blockchain",
    blurBox: true,
    align: 'left'
},

lynknight:{
    image: "https://i.ibb.co/VVc6srn/lkn-b.jpg",
    title: "Lynknight",
    body: `Lyn Knight has been a leader in the field of Numismatics and Collectibles for over 50 years. Curate and Monetize Unique Collections as Digital Collectibles and NFTs.`,
    footer: `Enable Auction houses and Brands to cross sell services to NFT owners.`,
    blurBox: true,
    align: 'left'
},

art:{
    image: "https://i.ibb.co/Ky2HpfM/art-banner.jpg",
    title: "Art",
    body: `Collecting art has generally been an honor of the chosen handful.`,
    footer: `Enable Artists and Organizations to cross sell services to NFT owners.`,
    blurBox: true,
    align: 'left'
},

banknote:{
    image: "https://i.ibb.co/3Nvv7mw/bank-note.jpg",
    title: "Bank Note",
    body: `Unlock $1 Billion market of Traditional “Physical” rare collectibles including coins and notes as NFTs. Address Human Desire and Natural Tendency to collect things that are eye-catching and rare.`,
    footer: `Enable leading brands to expand reach to Gen-Z by issuing collectibles.`,
    blurBox: true,
    align: 'left'
},


}


    